var _style, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 50,
    height: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41,49.7L41,49.7c-8.5-0.3-18.5-8.5-25.4-15.4C8.8,27.4,0.5,17.5,0.3,9C0.2,6.3,7.4,1,7.4,1c1.7-1.2,3.6-0.8,4.4,0.3 c0.6,0.8,6.2,9.3,6.8,10.2s0.5,2.2-0.3,3.6c-0.5,0.9-2.1,3.7-2.7,4.7c0.6,0.9,2.5,3.5,6.8,7.8s6.9,6.2,7.8,6.8 c1.1-0.6,3.9-2.2,4.7-2.7c1.3-0.7,2.7-0.8,3.6-0.3c1,0.6,9.4,6.2,10.2,6.8c0.6,0.4,0.9,1.1,1,1.9c0.1,0.6,0,1.5-0.7,2.5 C49,42.6,43.7,49.7,41,49.7z M9.6,1.8c-0.4,0-0.9,0.1-1.3,0.5C6,3.8,1.7,7.7,1.7,9c0.3,8,8.3,17.6,15,24.3S33.1,48,41,48.2l0,0 c1.3,0,5.2-4.3,6.8-6.5c0.3-0.5,0.5-1,0.5-1.5c0-0.4-0.2-0.7-0.4-0.8c-0.7-0.5-9.1-6.1-10.1-6.7c-0.3-0.2-1.1-0.2-2.1,0.3 s-5,2.8-5.1,2.9l-0.4,0.2l-0.4-0.2c-0.1-0.1-2.9-1.7-8.5-7.3c-5.5-5.5-7.2-8.3-7.3-8.5l-0.2-0.4l0.2-0.4c0,0,2.3-4,2.9-5.1 c0.5-1,0.5-1.8,0.3-2.1C16.6,11.2,11,2.7,10.5,2C10.4,1.9,10.1,1.8,9.6,1.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2d32041c.svg";
export { ForwardRef as ReactComponent };